import { useTranslation } from 'react-i18next';
import { useRegions, useDistricts } from '@/hooks/use-geo';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

interface Props {
  regionId: number | null;
  districtId: number | null;
  onChange: (next: { region_id: number | null; district_id: number | null }) => void;
}

const NONE = '__none__';

export default function RegionDistrictSelect({ regionId, districtId, onChange }: Props) {
  const { t } = useTranslation();
  const { data: regions = [] } = useRegions();
  const { data: districts = [] } = useDistricts(regionId);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
      <div>
        <label className="text-xs text-muted-foreground mb-1 block">{t('misc_geo.region')}</label>
        <Select
          value={regionId != null ? String(regionId) : NONE}
          onValueChange={v => onChange({ region_id: v === NONE ? null : Number(v), district_id: null })}
        >
          <SelectTrigger><SelectValue placeholder={t('misc_geo.pick_region')} /></SelectTrigger>
          <SelectContent>
            <SelectItem value={NONE}>{t('misc_geo.none')}</SelectItem>
            {regions.map(r => <SelectItem key={r.id} value={String(r.id)}>{r.name}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      <div>
        <label className="text-xs text-muted-foreground mb-1 block">{t('misc_geo.district')}</label>
        <Select
          value={districtId != null ? String(districtId) : NONE}
          disabled={!regionId}
          onValueChange={v => onChange({ region_id: regionId, district_id: v === NONE ? null : Number(v) })}
        >
          <SelectTrigger><SelectValue placeholder={t('misc_geo.pick_district')} /></SelectTrigger>
          <SelectContent>
            <SelectItem value={NONE}>{t('misc_geo.none')}</SelectItem>
            {districts.map(d => <SelectItem key={d.id} value={String(d.id)}>{d.name}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
